import { Routes, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { PermissionsEnum } from '../permission.enum';
import { permissionGuard } from '../shared/core/guard/permission.guard';
import { administrationMenuItems } from '../constant';
import { PermissionService } from '../permission.service';

import { Component } from '@angular/core';
@Component({ template: '' })
export class DummyComponent {}

function getCurrentOrgKey(): string | null {
  const storedUser = localStorage.getItem('currentUser');
  const parsedUser = storedUser ? JSON.parse(storedUser) : null;
  return parsedUser?.data?.orgKey ?? null;
}

function isMidaRef(): boolean {
  const storedUser = localStorage.getItem('currentUser');
  const parsedUser = storedUser ? JSON.parse(storedUser) : null;
  return parsedUser?.data?.orgKey === 'mida';
}

export const MidaGuardActivate: CanActivateFn = () => {
  const isMida = isMidaRef();

  if (isMida) {
    return true;
  }

  const router = inject(Router);
  return router.parseUrl('/administration/organisations');
};

export const AdministrationRedirectGuard: CanActivateFn = () => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  const firstAccessibleItem = administrationMenuItems.find((item) => permissionService.canShowNavItem(item));

  if (!firstAccessibleItem) {
    return router.parseUrl('/m/dashboard');
  }

  if (firstAccessibleItem.icon === 'organisation') {
    const isMida = isMidaRef();
    const orgKey = getCurrentOrgKey();
    return router.parseUrl(
      isMida ? '/m/administration/organisations-list' : `/m/administration/organisations/${orgKey}`
    );
  }

  return router.parseUrl(firstAccessibleItem.route);
};

export const administrationRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'organisations-list',
        canActivate: [MidaGuardActivate, permissionGuard(PermissionsEnum.OrganisationView)],
        loadComponent: () => import('./components/organisations/components/organisation-list/organisation-list.component').then((m) => m.OrganisationListComponent),
      },
      {
        path: 'organisations',
        canActivate: [permissionGuard(PermissionsEnum.OrganisationView)],
        loadComponent: () => import('./components/organisations/organisations.component').then((m) => m.OrganisationsComponent),
      },
      {
        path: 'organisations/:orgKey',
        canActivate: [permissionGuard(PermissionsEnum.OrganisationView)],
        loadComponent: () => import('./components/organisations/components/org-settings/org-settings.component').then((m) => m.OrgSettingsComponent),
      },
      {
        path: 'roles',
        canActivate: [permissionGuard(PermissionsEnum.RolesView)],
        loadComponent: () => import('./components/roles/roles.component').then((m) => m.RolesComponent),
      },
      {
        path: 'roles/edit-role/:id',
        loadComponent: () => import('./components/roles/components/roleupdate/roleupdate.component').then((m) => m.RoleUpdateComponent),
      },
      {
        path: 'roles/add-role',
        loadComponent: () => import('./components/roles/components/roleupdate/roleupdate.component').then((m) => m.RoleUpdateComponent),
      },
      {
        path: 'users',
        canActivate: [permissionGuard(PermissionsEnum.UsersView)],
        loadComponent: () => import('./components/users/users.component').then((m) => m.UsersComponent),
      },
      {
        path: 'groups',
        canActivate: [permissionGuard(PermissionsEnum.GroupView)],
        loadComponent: () => import('./components/groups/groups.component').then((m) => m.GroupsComponent),
      },
      {
        path: 'audit-logs',
        loadComponent: () =>
          import('./components/audit-logs/audit-logs.component').then((m) => m.AuditLogsComponent),
      },
      {
        path: 'webhooks',
        // Webhooks permission check disabled
        // canActivate: [permissionGuard(PermissionsEnum.WebhooksView)],
        loadComponent: () => import('./components/webhooks/webhooks.component').then((m) => m.WebhooksComponent),
      },
      {
        path: '',
        canActivate: [AdministrationRedirectGuard],
        pathMatch: 'full',
        component: DummyComponent,
      },
    ],
  },
];
